export default __webpack_public_path__ + "static/media/NR-BX471GPKA 1.ca2f3cf8.jpg";